export default function parseAttributeJson(s) {
  try {
    if (s) {
      return JSON.parse(s.replace('&ouot;', '"').replace('&uuot;', '"')) // strange bug
    } else {
      return {}
    }
  } catch (e) {
    throw new TypeError(s, 'parse.json.js', 9)
  }
}
